<div class="section" style="overflow: hidden !important">
  <div class="row">
    <div class="col-sm">
      <div class="close-header">
        <div style="cursor: pointer" (click)="oncancelClick()">
          <img
            src="assets/images/icons/close-icon.png"
            style="margin: 10px 10px; height: 11px; width: 11px"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="statement-table-container">
    <table mat-table [dataSource]="[]" class="statement-table-header">
      <ng-container matColumnDef="statementText">
        <th mat-header-cell *matHeaderCellDef class="centered bold">
          Statement Text
        </th>
      </ng-container>
      <ng-container matColumnDef="qualifier">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="centered bold"
          style="width: 195px !important"
        >
          Qualifier
        </th>
      </ng-container>
      <ng-container matColumnDef="marketingChannel">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="centered mat-column-marketingChannel bold"
        >
          Marketing Channel
        </th>
      </ng-container>
      <ng-container matColumnDef="supportStrategy">
        <th mat-header-cell *matHeaderCellDef class="centered bold">
          Support Strategy
        </th>
      </ng-container>
      <ng-container matColumnDef="substantiations">
        <th mat-header-cell *matHeaderCellDef class="centered bold">
          Substantiations
        </th>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        style="border-bottom: none !important"
      ></tr>
    </table>

    <!-- Saved in Draft -->
    <div class="section-label">Saved in Draft</div>
    <table mat-table [dataSource]="savedInDraft" class="statement-table">
      <ng-container matColumnDef="statementText">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="element.statementText"
            class="two-line-ellipsis"
            >{{ element.statementText }}</span
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="qualifier">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="element.qualifier"
            class="two-line-ellipsis"
            [ngClass]="{ bold: element.qualifierBold }"
            >{{ element.qualifier }}</span
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="marketingChannel">
        <td
          mat-cell
          *matCellDef="let element"
          class="mat-column-marketingChannel"
          style="padding-left: 7px !important"
        >
          <span class="marketing-channel">
            <ng-container *ngIf="!element.marketingChannelExpanded">
              <span
                *ngFor="let line of getMarketingChannelDisplay(element).lines"
                class="marketing-channel-line"
                >{{ line }}</span
              >
              <span
                *ngIf="getMarketingChannelDisplay(element).showEllipsis"
                class="ellipsis"
                (click)="expandMarketingChannel(element)"
                >...</span
              >
            </ng-container>
            <ng-container *ngIf="element.marketingChannelExpanded">
              <span
                *ngFor="let line of getMarketingChannelDisplay(element).lines"
                class="marketing-channel-line"
                >{{ line }}</span
              >
            </ng-container>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="supportStrategy">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="element.supportStrategy | safeHtml"
            class="two-line-ellipsis"
            [innerHTML]="element.supportStrategy"
          >
            <!-- {{ sanitizeHTML(element.supportStrategy) }} -->
          </span>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="substantiations">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="getSubstantiationIds(element)"
            class="two-line-ellipsis substantiation-link"
          >
            {{ getSubstantiationIds(element) }}
          </span>
        </td>
      </ng-container> -->
      <ng-container matColumnDef="substantiations">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="getSubstantiationDescriptionsTooltip(element)"
            class="two-line-ellipsis substantiation-link"
          >
            {{ getSubstantiationShortDescriptions(element) }}
          </span>
        </td>
      </ng-container>
      <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
        [ngClass]="{ 'odd-row': true }"
      ></tr>
    </table>

    <!-- Latest Updates -->
    <div class="section-label">Latest Updates</div>
    <table mat-table [dataSource]="latestUpdates" class="statement-table">
      <ng-container matColumnDef="statementText">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="element.statementText"
            class="two-line-ellipsis"
            >{{ element.statementText }}</span
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="qualifier">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="element.qualifier"
            class="two-line-ellipsis"
            [ngClass]="{ bold: element.qualifierBold }"
            >{{ element.qualifier }}</span
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="marketingChannel">
        <td
          mat-cell
          *matCellDef="let element"
          class="mat-column-marketingChannel"
          style="padding-left: 7px !important"
        >
          <span class="marketing-channel">
            <ng-container *ngIf="!element.marketingChannelExpanded">
              <span
                *ngFor="let line of getMarketingChannelDisplay(element).lines"
                class="marketing-channel-line"
                >{{ line }}</span
              >
              <span
                *ngIf="getMarketingChannelDisplay(element).showEllipsis"
                class="ellipsis"
                (click)="expandMarketingChannel(element)"
                >...</span
              >
            </ng-container>
            <ng-container *ngIf="element.marketingChannelExpanded">
              <span
                *ngFor="let line of getMarketingChannelDisplay(element).lines"
                class="marketing-channel-line"
                >{{ line }}</span
              >
            </ng-container>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="supportStrategy">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="element.supportStrategy | safeHtml"
            class="two-line-ellipsis"
            [innerHTML]="element.supportStrategy"
          >
            <!-- {{ sanitizeHTML(element.supportStrategy) }} -->
          </span>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="substantiations">
        <td mat-cell *matCellDef="let element" class="centered">
           <span
            [matTooltip]="getSubstantiationIds(element)"
            class="two-line-ellipsis substantiation-link"
          >
            {{ getSubstantiationIds(element) }}
          </span>
        </td>
      </ng-container> -->
      <ng-container matColumnDef="substantiations">
        <td mat-cell *matCellDef="let element" class="centered">
          <span
            [matTooltip]="getSubstantiationDescriptionsTooltip(element)"
            class="two-line-ellipsis substantiation-link"
          >
            {{ getSubstantiationShortDescriptions(element) }}
          </span>
        </td>
      </ng-container>
      <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
        [ngClass]="{ 'odd-row': true }"
      ></tr>
    </table>

    <div class="action-buttons">
      <button
        *ngIf="!isDeclineEnabled"
        mat-stroked-button
        class="btn-text-cancel"
        (click)="onDeclineLatestUpdates()"
      >
        Decline Latest Updates
      </button>
      &nbsp;
      <button
        mat-stroked-button
        class="btn-text-proceed"
        (click)="onAcceptLatestUpdates()"
      >
        Accept Latest Updates
      </button>
    </div>
  </div>
</div>
